export const formatCustomer = (customer) =>
  !customer ? {} : { customer_id: customer.customer_id, customer_name: customer.customer_name };
